<template>
  <el-row>
    <el-row>
      <el-col :span="20">
        <el-divider content-position="left">Owner</el-divider>
      </el-col>
      <el-col :span="4">
        <el-row type="flex" justify="end">
          <el-button size="small" @click="$router.go(-1)">Kembali</el-button>
          <el-button
            size="small"
            type="primary"
            @click="() => save([customer.owner, ...employee])"
          >Simpan</el-button>
        </el-row>
      </el-col>
    </el-row>
    <el-row>
      <template v-for="(form, idx) in formOwner">
        <el-col :span="12" :key="idx">
          <el-form-item
            v-if="idx >= 0 && idx <= 1"
            size="small"
            :prop="form.id"
            :label="form.label"
            :rules="form.rules"
          >
            <el-col :span="12">
              <el-input
                v-if="form.type == 'text' || form.type == 'number' || form.type == 'password'"
                v-model="customer.owner[form.id]"
                :type="form.type"
                :placeholder="`Please input ${form.label}`"
              ></el-input>
              <el-select
                v-else-if="form.type == 'select'"
                v-model="customer.owner[form.id]"
                :placeholder="`Please select ${form.label}`"
                style="width: 100%"
              >
                <el-option
                  v-for="item in optionsActiveOwner"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-col>
          </el-form-item>
        </el-col>
      </template>
    </el-row>
    <el-row>
      <template v-for="(form, idx) in formOwner">
        <el-col :span="24" :key="idx">
          <el-form-item
            v-if="idx >= 2 && idx <= 4"
            size="small"
            :prop="form.id"
            :label="form.label"
            :rules="form.rules"
          >
            <el-col :span="6">
              <el-input
                :show-password="form.type === 'password'"
                v-if="form.type == 'text' || form.type == 'number' || form.type == 'password'"
                v-model="customer.owner[form.id]"
                :type="form.type"
                :placeholder="`Please input ${form.label}`"
              ></el-input>
            </el-col>
          </el-form-item>
        </el-col>
      </template>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-divider content-position="left">Employee</el-divider>
      </el-col>
    </el-row>
    <el-table :data="customer.employee" style="width: 100%" max-height="250" class="mb-4">
      <el-table-column fixed type="index" label="No"></el-table-column>
      <el-table-column prop="userName" label="Username"></el-table-column>
      <el-table-column prop="fullName" label="FullName"></el-table-column>
      <el-table-column sortable prop="status" label="Status">
        <template slot-scope="scope">
          <el-select v-model="scope.row.status" placeholder="Select" disabled>
            <el-option
              v-for="item in optionsActiveEmployee"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="Operations">
        <template slot-scope="scope">
          <el-button size="mini" @click="toDetail(scope.row.userId)">Detail</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row>
      <template v-for="(form, idx) in formEmployee">
        <el-col :span="12" :key="idx">
          <el-form-item
            v-if="idx >= 0 && idx <= 1"
            size="small"
            :prop="form.id"
            :label="form.label"
            :rules="form.rules"
          >
            <el-col :span="12">
              <el-input
                v-if="form.type == 'text' || form.type == 'number' || form.type == 'password'"
                v-model="employee[form.id]"
                :type="form.type"
                :placeholder="`Please input ${form.label}`"
              ></el-input>
              <el-select
                v-else-if="form.type == 'select'"
                v-model="employee[form.id]"
                :placeholder="`Please select ${form.label}`"
                style="width: 100%"
              >
                <el-option
                  v-for="item in optionsActiveEmployee"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-col>
          </el-form-item>
        </el-col>
      </template>
    </el-row>
    <el-row>
      <template v-for="(form, idx) in formEmployee">
        <el-col :span="24" :key="idx">
          <el-form-item
            v-if="idx >= 2 && idx <= 3"
            size="small"
            :prop="form.id"
            :label="form.label"
            :rules="form.rules"
          >
            <el-col :span="6">
              <el-input
                v-if="form.type == 'text' || form.type == 'number' || form.type == 'password'"
                v-model="employee[form.id]"
                :type="form.type"
                :placeholder="`Please input ${form.label}`"
              ></el-input>
            </el-col>
          </el-form-item>
        </el-col>
      </template>
    </el-row>
    <el-row>
      <template v-for="(form, idx) in formEmployee">
        <el-col :span="12" :key="idx">
          <el-form-item
            v-if="idx >= 4 && idx <= 6"
            size="small"
            :prop="form.id"
            :label="form.label"
            :rules="form.rules"
          >
            <el-col :span="12">
              <el-input
                v-if="form.type == 'text' || form.type == 'number' || form.type == 'password'"
                v-model="employee[form.id]"
                :type="form.type"
                :placeholder="`Please input ${form.label}`"
              ></el-input>
              <el-checkbox-group v-model="employee[form.id]" v-else-if="form.type == 'checkbox'">
                <el-checkbox label="ORDER ITEM" name="accountUsage"></el-checkbox>
                <el-checkbox label="RECEIVE ITEM" name="accountUsage"></el-checkbox>
                <el-checkbox label="RETURN ITEM" name="accountUsage"></el-checkbox>
              </el-checkbox-group>
            </el-col>
          </el-form-item>
        </el-col>
      </template>
    </el-row>
  </el-row>
</template>

<script>
export default {
  props: ["customer", "save"],
  name: "Employee",
  data() {
    return {
      optionsActiveOwner: [
        { label: "Active", value: "A" },
        { label: "Tidak Active", value: "N" }
      ],
      optionsActiveEmployee: [
        { label: "Active", value: "A" },
        { label: "Tidak Active", value: "N" }
      ],
      id: null,
      tempEmployee: {
        accountUsage: [],
        email: "",
        fullName: "",
        password: "",
        status: "N",
        userId: "",
        userName: "",
        userType: ""

      }
    };
  },
  methods: {
    toDetail(id) {
      this.id = id;
    }
  },
  computed: {
    employee() {
      if (this.customer.employee.length > 0) {
        let tempId;
        if (this.id === null) {
          tempId = this.customer.employee[0].userId
        } else {
          tempId = this.id
        }
        const filteredEmployee = this.customer.employee.filter(item => {
          return item.userId == tempId;
        })
        return filteredEmployee[0];
      } else {
        return this.tempEmployee
      }
    },
    formOwner() {
      return [
        {
          type: "text",
          id: "userName",
          label: "Username",
          rules: []
        },
        {
          type: "select",
          id: "status",
          label: "Status",
          rules: []
        },
        {
          type: "password",
          id: "password",
          label: "Password",
          rules: []
        },
        {
          type: "text",
          id: "email",
          label: "Email",
          rules: []
        },
        {
          type: "text",
          id: "userType",
          label: "User Type",
          rules: []
        }
      ];
    },
    formEmployee() {
      return [
        {
          type: "text",
          id: "userName",
          label: "Username",
          rules: []
        },
        {
          type: "select",
          id: "status",
          label: "Status",
          rules: []
        },
        {
          type: "text",
          id: "password",
          label: "Password",
          rules: []
        },
        {
          type: "text",
          id: "userType",
          label: "User Type",
          rules: []
        },
        {
          type: "text",
          id: "fullName",
          label: "Name",
          rules: []
        },
        {
          type: "text",
          id: "email",
          label: "Email",
          rules: []
        },
        {
          type: "checkbox",
          id: "accountUsage",
          label: "Account Usage",
          rules: []
        }
      ];
    }
  }
};
</script>

<style>
</style>
